function domReady() {
    return new Promise(resolve => {
        if (document.readyState !== 'loading') {
            resolve();
        } else {
            document.addEventListener('DOMContentLoaded', resolve);
        }
    });
}

// Element that triggered the popup, so focus can be restored on close.
var findationTriggerElement = null;

// Findation's popup iframe is cross-origin, so we can only trap focus by
// watching for it landing back in our own document and pulling it back in.
var handleFindationFocusIn = null;

function trapFocusInFindationPopup(popupEl) {
    releaseFindationFocusTrap();

    handleFindationFocusIn = function (e) {
        if (e.target !== popupEl) {
            popupEl.focus();
        }
    };

    document.addEventListener('focusin', handleFindationFocusIn, true);
}

function releaseFindationFocusTrap() {
    if (handleFindationFocusIn) {
        document.removeEventListener('focusin', handleFindationFocusIn, true);
        handleFindationFocusIn = null;
    }
}

// The SDK script loads async, so it may still be mid-download once the DOM
// is ready - wait for whichever of the two finishes last.
function findationSdkReady() {
    return new Promise(function (resolve) {
        if (window.Findation && window.Findation.init) {
            resolve();
            return;
        }
        var sdkScript = document.getElementById('findation-sdk');
        if (sdkScript) {
            sdkScript.addEventListener('load', resolve, { once: true });
        }
    });
}

// `button` targets an offscreen proxy so our real button stays under our own
// control (see click handler below). Resolves on widgetEmbedded, not init()
// returning, since openWidget() stays a "not embedded" stub until then.
var findationInitPromise = Promise.all([domReady(), findationSdkReady()]).then(function () {
    return new Promise(function (resolve) {
        var findationWidget = document.getElementById("findation-widget");
        var findationOutOfStockLabel = findationWidget.getAttribute("data-out-of-stock-label");

        window.Findation = window.Findation || {};
        window.Findation.widgetEmbedded = resolve;
        window.Findation.init({
            apiKey: findationWidget.getAttribute("data-api-key"),
            button: "#findation-proxy-button",
            demo: (findationWidget.getAttribute("data-demo-mode") === 'true')
        });
        window.Findation.resultsWillRender = function(html) {

            console.log('Results will render', html);
        };
        window.Findation.widgetDidOpen = function() {
            console.log('Widget did open');

            // Reliable signal for the "CTA open" tracking event.
            window.dataLayer.push({
                event: 'product_page_interaction',
                interactionType: 'Findation'
            });

            findationTriggerElement = document.activeElement;

            // Its internal focus/close-button handling is out of our control
            // since the popup iframe is a cross-origin document.
            var findationFrame = document.getElementById('findation-iframe');
            if (findationFrame) {
                findationFrame.focus();
                trapFocusInFindationPopup(findationFrame);
            }

        };

        window.Findation.widgetDidClose = function() {
            console.log('Widget did close');
            releaseFindationFocusTrap();

            // Fall back to the button if the trigger reference is gone.
            var triggerButton = findationTriggerElement
                || document.getElementById('findation-button-iframe')
                || document.getElementById('findation-widget-button');

            if (triggerButton) {
                triggerButton.focus();
            }

            findationTriggerElement = null;
        };

        window.Findation.onSearchComplete = function(data) {
            console.log('Search complete', data);
        };

        window.Findation.resultsWillRender = function(html) {
            console.log('Results will render', html);
            var tmp = document.createElement('div');
            tmp.innerHTML = html;
            var $element = $(tmp);
            var externalIdValue = $element.find('.external_id').val();
            var variantUrl = findationWidget.getAttribute("data-variant-url");
            if (!variantUrl || !externalIdValue) {
                return;
            }

            variantUrl += '?pid=' + externalIdValue;
            $.spinner().start();
            $.ajax({
                url: variantUrl,
                method: 'GET',
                // async: false so the swatch is inserted before we return tmp.innerHTML.
                async: false,
                success: function (data) {
                    var colorHex = data.product.CORE_single_shade_hexa_code;
                    var shadeNumber = data.product.CORE_shade_number;
                    $element.find('.external_id').attr('data-custom-CORE_single_shade_hexa_code', colorHex);
                    $element.find('.external_id').attr('data-custom-CORE_shade_number', shadeNumber);

                    var swatchPlaceholder = $element.find('.swatch-placeholder')[0];
                    if (colorHex && swatchPlaceholder) {
                        var swatch = document.createElement('div');
                        var swatchStyle = 'width:33px;height:51px;background:' + colorHex + ';margin:24px auto 10px;';
                        if (data.product.available === false) {
                            // Diagonal out-of-stock slash across the swatch.
                            swatchStyle += 'background-image:linear-gradient(to bottom right, transparent calc(50% - 1px), #3F2E27, transparent calc(50% + 1px));';
                        }
                        swatch.setAttribute('style', swatchStyle);
                        swatchPlaceholder.appendChild(swatch);

                        if (shadeNumber) {
                            var shadeNumberLabel = document.createElement('div');
                            shadeNumberLabel.textContent = shadeNumber;
                            shadeNumberLabel.setAttribute('style', 'color:#3F2E27;text-align:center;margin-bottom:12px;font-size:16px;font-weight:400;text-transform:uppercase;');
                            swatchPlaceholder.appendChild(shadeNumberLabel);
                        }
                    }

                    if (data.product.available === false) {
                        var addToCartBtn = $element.find('a.btn-primary')[0];
                        if (addToCartBtn) {
                            addToCartBtn.setAttribute('disabled', 'disabled');
                            addToCartBtn.style.pointerEvents = 'none';
                            addToCartBtn.style.opacity = '0.65';
                            addToCartBtn.style.boxShadow = 'none';
                            addToCartBtn.style.cursor = 'not-allowed';
                            addToCartBtn.style.background = "#eef2f2";
                            addToCartBtn.textContent = findationOutOfStockLabel;
                        }
                    }

                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                }
            });
            return tmp.innerHTML;
        };
        window.Findation.onActionReceived = function(data) {
            console.log('Add to cart: ', data);
            $.spinner().start();
            var addToCartUrl = $('.add-to-cart-vto-url').val() || $('.add-to-cart-url').val();

            if (!addToCartUrl || data === undefined || !data.pid) {
                return;
            }
            $('body').trigger('product:beforeAddToCart');
            var form = {
                pid: data.pid,
                quantity: 1
            };
            $.ajax({
                url: addToCartUrl,
                method: 'POST',
                data: form,
                success: function (data) {
                    $('.minicart').trigger('count:update', data);
                    $('body').trigger('product:afterAddToCart', data);
                    window.Findation.closeWidget();
                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        };
    });
});

// Attached as soon as the DOM is ready, independent of the SDK finishing.
domReady().then(function () {
    var findationButton = document.getElementById('findation-widget-button');
    if (!findationButton) {
        return;
    }

    findationButton.addEventListener('click', function (e) {
        e.preventDefault();
        $.spinner().start();
        findationInitPromise.then(function () {
            $.spinner().stop();
            window.Findation.openWidget();
        });
    });
});
